import { useMutation } from '@apollo/client/react';
import { Typography } from '@mui/material';
import { Trash2Icon } from 'lucide-react';

import { gql } from '@graphql/__generated__';
import { SlideDialog } from '@modules/_shared/components/SlideDialog';
import { useLocale } from '@shared/hooks/locale';

type Props = {
  fileId: string;
  open: boolean;
  onDelete?: (id: string) => void;
  onClose: () => void;
};

const DELETE_FILE = gql(/* GraphQL */ `
  mutation DeleteFile($id: uuid!) {
    delete_files_by_pk(id: $id) {
      id
    }
  }
`);

export const FileDeleteDialog = (props: Props) => {
  const { t } = useLocale();
  const [deleteFile, { loading: deleting }] = useMutation(DELETE_FILE);

  const handleDelete = () => {
    deleteFile({
      variables: { id: props.fileId },
      onCompleted: () => {
        props.onDelete?.(props.fileId);
        props.onClose();
      },
    });
  };

  return (
    <SlideDialog
      open={props.open}
      onClose={props.onClose}
      title={t('Delete file')}
      onSave={handleDelete}
      loading={deleting}
      maxWidth="sm"
      fullWidth
      cancelText={t('Cancel')}
      saveText={t('Delete')}
      saveColor="error"
      saveIcon={<Trash2Icon />}
    >
      <Typography sx={{ p: 2 }}>
        {t('Are you sure you want to delete this file')}
      </Typography>
    </SlideDialog>
  );
};
